import type { StateCreator } from 'zustand'

import { type DarkModeState, INITIAL_STATE } from './types'

const createDarkModeSlice: StateCreator<DarkModeState, [], [], DarkModeState> = (set) => ({
  darkMode: INITIAL_STATE,
  setIsDarkMode: (isDarkMode) => set(() => ({ darkMode: { isDarkMode } })),
})

export default createDarkModeSlice
